import { render, staticRenderFns } from "./double-twelve.vue?vue&type=template&id=2fc8d026&scoped=true"
import script from "./double-twelve.vue?vue&type=script&lang=js"
export * from "./double-twelve.vue?vue&type=script&lang=js"
import style0 from "./double-twelve.vue?vue&type=style&index=0&id=2fc8d026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc8d026",
  null
  
)

export default component.exports